import { Component, OnInit, HostListener, Input, Renderer, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DeviceDetectorService } from "ngx-device-detector";
import { AppService } from "../app-service/app-service.service";
import { Router } from "@angular/router";
import { environment } from "../../../../environments/environment";
import { TestObject } from "protractor/built/driverProviders";
import { FormGroup, FormControl } from "@angular/forms";
import { SelectListComponent } from "../forms/select-list/select-list.component";
import { LoginService } from "../../login/services/login.service";
import { AuthInfo } from "../../../model/entities/login/authInfo";

@Component({
  selector: "aqualia-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavbarComponent implements OnInit {
  hasNotifications: boolean = false;
  numberNotifications: number = null;
  showName: boolean = false;
  isMobile: boolean = false;
  initials: string = "";
  formInputUserRoles: FormGroup;

  @ViewChild("GetUserRoles") selectListGetUserRoles: SelectListComponent;

  @Input("isMobile")
  set checkMobile(mobile: boolean) {
    this.isMobile = mobile;
    this.navbarService.mobileDevice = mobile;
  }

  constructor(
    private cdr: ChangeDetectorRef,
    public navbarService: AppService,
    private translate: TranslateService,
    private deviceService: DeviceDetectorService,
    private loginService: LoginService,
    private router: Router,
    public renderer: Renderer,
    public element: ElementRef
  ) {
    this.formInputUserRoles = new FormGroup({
      Role: new FormControl("")
    });
  }

  async ngOnInit() {
    await this.navbarService.checkLogged();
    this.cdr.detectChanges();
    if (this.navbarService.existMenu) {
      setTimeout(() => {
        this.cdr.detectChanges();
        this.checkActualPage();
      }, 10);
    }
    this.checkDevice();

    this.takeinitials(this.navbarService.userInfo.fullName);

    if (this.navbarService.MultiUser) {
      this.selectListGetUserRoles.selectElementById(this.navbarService.userInfo.userId);
    }
  }

  takeinitials(FullName) {
    if (FullName != "" || FullName != undefined || FullName != null) {
      let arrayFullName = FullName.split(" ");
      this.initials = "";

      if (arrayFullName.length == 1) {
        this.initials = this.initials + arrayFullName[0].slice(0, 1);
      } else {
        this.initials = this.initials + arrayFullName[0].slice(0, 1);
        this.initials = this.initials + arrayFullName[1].slice(0, 1);
      }
    }
  }

  logout() {
    sessionStorage.removeItem(environment.userStorage);
    this.navbarService.iconBreadCrumb = undefined;
    this.navbarService.existMenu = false;
    this.navbarService.checkLogged();
    this.navbarService.saveInLocal(environment.manualLogin, true);
    this.router.navigate(["/"]);
  }

  checkDevice() {
    let device = this.deviceService.getDeviceInfo().device;

    if (device != "unknown") {
      this.navbarService.mobileDevice = true;
    }
    if (window.innerWidth <= 1250) {
      this.showName = false;
    } else {
      this.showName = true;
    }
  }

  checkActualPage() {
    let elementToSearch = "nav" + window.location.pathname.split("/")[1];
    if (elementToSearch == 'nav') {
      elementToSearch = 'navhome';
    }
    let element = this.element.nativeElement.getElementsByClassName(elementToSearch)[0];
    if (element != null && this.renderer != null) {
      this.renderer.setElementClass(element, "actualPage", true);
    }
    //SubLevel
    if (window.location.pathname.split("/").length == 3) {
      let subPageToSearch = window.location.pathname.split("/")[2];
      let subPage = this.element.nativeElement.getElementsByClassName(subPageToSearch)[0];
      if (subPage != null && this.renderer != null) {
        this.renderer.setElementClass(subPage, "actualSubPage", true);
      }
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    if (event.target.innerWidth <= 1250) {
      this.showName = false;
    } else {
      this.showName = true;
    }
  }

  changeActualPage(newPage) {
    let oldElement = this.element.nativeElement.getElementsByClassName("actualPage")[0];
    if (oldElement) {
      this.renderer.setElementClass(oldElement, "actualPage", false);
    }
    let elementToSearch = "nav" + newPage.split("/")[0];
    let element = this.element.nativeElement.getElementsByClassName(elementToSearch)[0];
    if (element) {
      this.renderer.setElementClass(element, "actualPage", true);
    }
    //SubLevel
    let oldSubPage = this.element.nativeElement.getElementsByClassName("actualSubPage")[0];
    let newElementToSearch = "nav" + newPage.split("/")[0];
    let newElement = this.element.nativeElement.getElementsByClassName(newElementToSearch)[0];
    if (newElement) {
      this.renderer.setElementClass(newElement, "actualPage", true);
    }
    if (oldSubPage) {
      this.renderer.setElementClass(oldSubPage, "actualSubPage", false);
    }
    if (newPage.split("/").length == 2) {
      let subPageToSearch = newPage.split("/")[1];
      let subPage = this.element.nativeElement.getElementsByClassName(subPageToSearch)[0];
      if (subPage != null && this.renderer != null) {
        this.renderer.setElementClass(subPage, "actualSubPage", true);
      }
    }
  }

  navigateTo(element, event) {
    if (element.link != null && element.link != "vacio") {
      if (event.ctrlKey || event.metaKey || event.button === 1) {
        setTimeout(() => {
          window.open(environment.protocol + "://" + window.location.host + "/" + element.link);
        }, 10);
      } else {
        this.router.navigate([element.link]);
        this.changeActualPage(element.link);
      }
    }
  }

  CheckOneLevel(SubLevels) {
    return SubLevels.filter(x => x.SubLevels != null).length == 0;
  }

  ChangeRol(value) {
    this.navbarService.setLoadingTrue();
    sessionStorage.removeItem(environment.userStorage);
    this.navbarService.iconBreadCrumb = undefined;
    this.navbarService.existMenu = false;
    this.navbarService.checkLogged();

    let authInfo: AuthInfo = new AuthInfo();
    authInfo.UserId = value.id;
    this.loginService.CreateToken(authInfo).subscribe(
      async result => {
        if (result != null && result != undefined) {
          // Go to Home
          window.sessionStorage.clear();
          this.navbarService.saveInLocal(environment.jwt, result.token);
          // bring the user's information
          let user = await this.loginService.UserInfo().toPromise();

          this.navbarService.saveInLocal(environment.userStorage, user);
          this.router.navigate(["/home"]);
          await this.navbarService.checkLogged();
          if (this.navbarService.existMenu) {
            setTimeout(() => {
              this.checkActualPage();
            }, 10);
          }
          this.checkDevice();

          this.takeinitials(this.navbarService.userInfo.fullName);

          if (this.navbarService.MultiUser) {
            this.selectListGetUserRoles.selectElementById(this.navbarService.userInfo.userId);
          }

        } else {
          this.router.navigate([""]);
        }
        this.navbarService.setLoadingFalse();
      }
    );
  }
}
